const token = localStorage.getItem('token')

export const resetPasswordAuth = {
    'accessToken':  `${token}`,
    'Authorization': 'Basic ZmVkb3JhOmZlZG9yYQ===='
}
